





























































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Confirm from '@/components/Confirm.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { EOrigin, EUserPermissions, EUserStatus, IChain, IFacility, IFacilityFiltersDTO, IManualPCCToggles, IPayerType, IUser } from '@zunta/configurations'
import { getFacilityCompleteLevel, getFacilityCompleteLevelObject, getFacilityGeneralInfoCompleteLevel } from '@/utils/facility/facilityLevels'
import Api from '@/api'
import formatters from '@/utils/formatters'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Card from '@/components/Card.vue'
import { ChainModule } from '@/store/modules/chain.module'
import AddFacilityModal from '@/views/app/management/settings/components/AddFacilityModal.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import { Debounce } from 'vue-debounce-decorator'
import Switcher from '@/components/Switcher.vue'
import { UserModule } from '@/store/modules/user.module'
import { ResidentModule } from '@/store/modules/resident.module'
import { isProductionEnv } from '@/utils/helpers'

@Component({
  filters: formatters,
  components: {
    StatusFacilityComplete,
    AddFacilityModal,
    Card,
    Table,
    FacilityLabel,
    Icon,
    Confirm,
    Switcher
  }
})
export default class Facilities extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  getFacilityCompleteLevel = (facility: IFacility) => getFacilityCompleteLevel({
    facility,
    users: this.users,
    facilitiesActivePayerTypesMap: this.facilitiesActivePayerTypesMap,
    contactListType: this.chainTypeOfContactListMap
  })
  getFacilityGeneralInfoCompleteLevel = getFacilityGeneralInfoCompleteLevel
  EUserPermissions: any = EUserPermissions
  user: any = Api.getUser()
  facilityForDelete: IFacility | null = null
  deletingFacility: boolean = false
  confirmDeleteOpened: boolean = false
  showAddFacilityModal: boolean = false
  windowWidth: number = window.innerWidth
  updater: number = 0
  filters: IFacilityFiltersDTO = {
    skip: 0,
    limit: 20
  }
  toggles: IManualPCCToggles | null = {}
  showToggleConfirm: boolean = false
  toggleToChange: IManualPCCToggles | null = null

  get users (): IUser[] {
    return this.$store.state.user.users
  }

  get isSmallScreen (): boolean {
    return this.windowWidth < 1400
  }

  get config (): ITableConfig {
    const config: ITableConfig = {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      usePagination: true,
      useQuery: true,
      fetchFunction: this.fetchFacilities,
      rowClick: this.goFacilitySettings,
      maxHeight: 'calc(100vh - 365px)',
      minHeight: 'calc(100vh - 365px)',
      columns: []
    }
    config.columns = [
      {
        minWidth: '290px',
        width: 33,
        key: 'name',
        searchKey: 'name',
        label: 'Name',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '165px',
        width: 16.6,
        key: 'cityState',
        searchKey: 'cityState',
        label: 'City, State',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '125px',
        width: 16.6,
        key: 'manager',
        searchKey: 'manager',
        label: 'Billing Manager',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '90px',
        width: 16.6,
        // class: 'text-center',
        key: 'billingDay',
        searchKey: 'billingDay',
        label: 'Statement Cycle',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '90px',
        width: 8.2,
        // class: 'text-center',
        key: 'residentsCount',
        searchKey: 'residentsCount',
        class: 'text-right',
        headClass: 'bt-justify-content-end',
        label: 'Residents',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '90px',
        width: 8,
        // class: 'text-center',
        key: 'usersCount',
        searchKey: 'usersCount',
        class: 'text-right',
        headClass: 'bt-justify-content-end',
        label: 'Users',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '160px',
        width: 17.2,
        class: 'bt-d-flex bt-align-items-center bt-justify-content-end',
        key: 'actions'
      }
    ]

    if (this.isSmallScreen) {
      config.columns = [
        {
          minWidth: '145px',
          width: 33,
          key: 'name',
          searchKey: 'name',
          label: 'Name',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '85px',
          width: 16.6,
          key: 'cityState',
          searchKey: 'cityState',
          label: 'City, State',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '130px',
          width: 16.6,
          key: 'manager',
          searchKey: 'manager',
          label: 'Billing Manager',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '88px',
          width: 16.6,
          // class: 'text-center',
          key: 'billingDay',
          searchKey: 'billingDay',
          label: 'Statement Cycle',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '72px',
          width: 8.2,
          // class: 'text-center',
          key: 'residentsCount',
          searchKey: 'residentsCount',
          class: 'text-right',
          headClass: 'bt-justify-content-end',
          label: 'Residents',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '65px',
          width: 8,
          // class: 'text-center',
          key: 'usersCount',
          searchKey: 'usersCount',
          class: 'text-right',
          headClass: 'bt-justify-content-end',
          label: 'Users',
          hasSort: true,
          hasSearch: true,
          type: ETableColumnType.default
        },
        {
          minWidth: '100px',
          width: 17.2,
          class: 'bt-d-flex bt-align-items-center bt-justify-content-end',
          key: 'actions'
        }
      ]
    }

    return config
  }

  get chain () {
    return this.chainModuleInstance.getChain || {} as IChain
  }

  get totalFacilities () {
    return this.$store.state.facility.total
  }

  get facilityList () {
    return this.$store.state.facility.facilities
  }

  get facilitiesActivePayerTypesMap (): { [k: string]: IPayerType[] } {
    return this.$store.state.facility.facilitiesActivePayerTypesMap
  }

  get isAllFacilityUsersCount () {
    return this.$store.state.user.users.filter((user: IUser) => user.isAllFacilities).length
  }

  get chainTypeOfContactListMap (): { [k: string]: string[] } {
    return this.$store.state.resident.chainTypeOfContactListMap
  }

  async mounted () {
    if (this.$route.query.importFacilities === 'true') {
      this.openPccLogin()
    }
    await Promise.all([
      this.residentModuleInstance.fetchChainTypeOfContactListMap(),
      this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
    ])
    this.initManualPccToggles()
    window.addEventListener('resize', this.setWW)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.setWW)
  }

  setWW () {
    this.windowWidth = window.innerWidth
  }

  tableLoadFacilities () {
    // @ts-ignore
    const table: any = this.$refs.table
    if (table) {
      table.initSearch()
    }
  }

  openPccLogin () {
    this.$router.push({ name: 'management-facilities-login' })
  }

  openDeleteConfirm (facility: IFacility) {
    this.facilityForDelete = facility
    this.confirmDeleteOpened = true
  }

  closeDeleteConfirm () {
    this.facilityForDelete = null
    this.confirmDeleteOpened = false
  }

  async deleteSelectedFacility () {
    if (!this.facilityForDelete) {
      return
    }
    this.deletingFacility = true
    const response = await this.facilityModuleInstance.deleteFacility(this.facilityForDelete.id as number)
    this.deletingFacility = false
    this.facilityForDelete = null
    this.confirmDeleteOpened = false
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Process Started',
        header: `Delete Facility...`,
        icon: 'check'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Process Failed',
        header: `Delete Facility...`,
        icon: 'warning'
      })
    }
    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.table.initSearch()
      this.initManualPccToggles()
      this.$forceUpdate()
    })
  }

  async fetchFacilities (filters: IFacilityFiltersDTO) {
    await this.facilityModuleInstance.getFacilityList(filters)
    const map: number[] = this.facilityList.map((facility: IFacility) => facility.id)
    await this.facilityModuleInstance.fetchFacilitiesActivePayerTypesMap(map)
    this.$nextTick(async () => {
      this.initManualPccToggles()
      this.updater++
      this.$forceUpdate()
    })
  }

  async goFacilitySettings (facility: IFacility) {
    if (this.user.hasPermissionFor(EUserPermissions.VIEW_FACILITIES)) {
      await this.facilityModuleInstance.getFacility(facility.id)
      this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL(getFacilityCompleteLevelObject({
        facility,
        facilitiesActivePayerTypesMap: this.facilitiesActivePayerTypesMap,
        users: this.users,
        contactListType: this.chainTypeOfContactListMap
      }))
      this.$router.push({
        name: 'management-facilities-settings-information',
        params: {
          id: (facility.id as number).toString()
        }
      })
    }
  }

  onShowFacilityModal () {
    if (this.chain && this.chain.billingSoftware === EOrigin.PCC) {
      this.onAddFacility({
        billingSoftware: EOrigin.PCC
      })
      return
    }

    this.showAddFacilityModal = true
  }

  async onAddFacility (event: any) {
    this.showAddFacilityModal = false
    if (event.billingSoftware === EOrigin.PCC) {
      this.openPccLogin()
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Process Started',
      header: `Add Facility...`,
      icon: 'check'
    })
    const data: IFacility = await this.facilityModuleInstance.createFacility({
      street: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      origin: event.billingSoftware,
      originid: event.originid || '',
      usersCount: this.isAllFacilityUsersCount,
      name: event.facilityName as string,
      directory: event.directory || '',
      statementNumberStart: 1000,
      chain: -1,
      reviewStatementsBeforeMailing: true
    })
    this.$eventBus.$emit('reload-facility-list')
    await this.goFacilitySettings(data)
  }

  initManualPccToggles () {
    const pccFacilities = (this.facilityList || []).filter((f: IFacility) => f.origin === EOrigin.PCC)
    if (!pccFacilities.length) {
      this.toggles = null
      return null
    }

    this.toggles = {
      useManualPCCImport: pccFacilities.every((f: IFacility) => f.useManualPCCImport),
      useManualPCCPush: pccFacilities.every((f: IFacility) => f.useManualPCCPush)
    }
    return this.toggles
  }

  async setManualPccToggles (togglesUpdate: IManualPCCToggles) {
    this.toggleToChange = togglesUpdate
    if (isProductionEnv()) {
      this.showToggleConfirm = true
      return
    }
    return this.updateManualPCCToggles()
  }

  async updateManualPCCToggles () {
    if (this.toggles) {
      this.toggles = { ...this.toggles, ...this.toggleToChange }
      await this.facilityModuleInstance.toggleManualPCCForChain(this.toggles)
      await this.fetchFacilities(this.filters)
    }
    this.toggleToChange = null
    this.showToggleConfirm = false
  }
}
